export default __webpack_public_path__ + "static/media/finishLogo.e455b0ba.svg";